import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Toro } from '../../api/common/enumerations';
import { AccountManagerService } from '../../api/managers/account-manager.service';
import { ApplicationStateManagerService } from '../../api/managers/application-state-manager.service';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';
import { MailCenterManagerService } from '../../api/managers/mail-center-manager.service';
import { ToroAccountSimple } from '../../api/models/toro-account-simple.model';
import { User } from '../../api/models/user.model';
import { BroadcastService } from '../../services/broadcast.service';
import { LoggingService } from '../../services/logging.service';
import { AlertsService } from '../alerts/alerts.service';
import { Store } from '@ngrx/store';
import { AuthState } from './../../auth/store/auth.entity';
import { loggedInUser } from './../../auth/store/auth.selectors';

@Component({
    selector: 'app-top-menu-bar',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class TopMenuComponent implements OnInit, OnDestroy {
    @Input() isUnAuthenticatedRoute = false;

    user: User;
    accountsList: ToroAccountSimple[] = [];
    isMailCenterLoadingMessages: boolean;
    isMobileWidth = false;

    constructor(private loginAndUserManagerService: LoginAndUserManagerService,
        private router: Router,
        private alertService: AlertsService,
        private accountManagerService: AccountManagerService,
        private applicationStateManager: ApplicationStateManagerService,
        private broadcastService: BroadcastService,
        //private localCacheManager: LocalCacheManager,
        public mailCenterManager: MailCenterManagerService,
        public authStore: Store<AuthState>
    ) {
        this.isMobileWidth = this.applicationStateManager.isMobileWindowWidth;
    }

    // =========================================================================================================================================================
    // C'tor, Init and Destroy
    // =========================================================================================================================================================

    ngOnInit() {
        // Subscribe to user changed event
        // this.loginAndUserManagerService.userChanged
        //     .pipe(untilDestroyed(this))
        //     .subscribe(user =>
        //     {
        //         this.user = user;
        //         this.aggregateAccounts(user);
        //     });

        this.authStore.select(loggedInUser).subscribe(user => {
            this.user = user;
            this.aggregateAccounts(user);
        })
        setTimeout(() => {
            this.isMailCenterLoadingMessages = this.mailCenterManager.isLoadingMessages;
        });

        this.applicationStateManager.windowResize
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                setTimeout(() => {
                    this.isMobileWidth = this.applicationStateManager.isMobileWindowWidth;
                }, 10);
            });

    }

    ngOnDestroy() {
        /* Implemented to support untilDestroyed() */
    }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    get isHamburgerMenuExpanded() {
        return this.applicationStateManager.isHamburgerMenuExpanded;
    }

    public toggleHamburgerMenu() {
        this.applicationStateManager.isHamburgerMenuExpanded = !this.applicationStateManager.isHamburgerMenuExpanded;
    }

    public toggleMailCenter() {
        this.applicationStateManager.mailCenterIsDisplayed = !this.applicationStateManager.mailCenterIsDisplayed;
    }

    onSignOut() {
        this.mailCenterManager.isMailCenterInitialized = false;
        this.loginAndUserManagerService.signOut();
    }

    onGoHome() {
        const irrigationStr = 'irrigation';
        const lightingStr = 'lighting';
        const url = this.router.url;
        let link = '/';

        if (url.includes(irrigationStr)) {
            const position = url.indexOf(irrigationStr);
            link = `${url.substr(0, position + irrigationStr.length)}/`;
        }
        else if (url.includes(lightingStr)) {
            const position = url.indexOf(lightingStr);
            link = `${url.substr(0, position + lightingStr.length)}/`;
        }

        this.router.navigate([`${link}`]);
    }

    onLogoClick() {
        if (!this.isUnAuthenticatedRoute) return;

        this.router.navigate(['/welcome']);
    }

    isCurrentAccount(index: number) {
        // TODO: Current account is not being set during initial visit to site (in all cases)

        if (this.accountsList.length < 1 || !this.accountManagerService.currentAccount) {
            return false;
        }

        return this.accountManagerService.currentAccount.Id === this.accountsList[index].Id;
    }

    private aggregateAccounts(user: User) {
        if (!this.user) {
            return;
        }

        if (this.user.AccountsAdministered) {
            this.user.AccountsAdministered.forEach(account => {
                this.accountsList.push(account);
            });
        }

        if (this.user.AccountsRepresenting) {
            this.user.AccountsRepresenting.forEach(account => {
                this.accountsList.push(account);
            });
        }
    }

    //
    // For Test
    //

    onSendAlert() {
        this.alertService.sendCriticalAlert('Danger! Danger Will Robinson!');
    }

    onClearAlert() {
        this.alertService.clearCriticalAlert();
    }

}
